import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/ui/animations")({
    beforeLoad: () => {
        throw redirect({ to: "/design/icons/animations", replace: true });
    },
});
